var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"research"},_vm._l((_vm.imgList),function(item,index){return _c('div',{key:index,staticClass:"headImg"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(item),expression:"item"}],attrs:{"alt":""}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }